<template>
  <div name="challenges" class="pb-6 ">

    <header class="px-6 mx-4">
      <div class="flex justify-between">
        <div>
          <h2 class="text-xl font-semibold w-64 inline-block">
           <img src="@/assets/images/challenges/logo_vertical.svg">
          </h2>
          <div class="text-gray-500 pb-4">
           Are you ready! Take a challenge below.
          </div>
        </div>

        <div>
          <button v-if="showingGrid" @click="startRamdomSelection()"  
          type="button"
          class="filter-bar-button focus:outline-none hover:opacity-75">
            <i class="fas fa-random text-xl pr-2"></i> <span>Lucky Dip</span></button>
          <button
            type="button"
            class="filter-bar-button focus:outline-none hover:opacity-75"
            v-bind:class="showingGrid ? 'filter-item-button-on' : 'bg-white'"
            @click="switchTypeView()"
          >
            <i class="fas fa-table text-lg pt-1"></i>
          </button>
          <button
            type="button"
            class="filter-bar-button focus:outline-none hover:opacity-75"
            v-bind:class="!showingGrid ? 'filter-item-button-on' : 'bg-white'"
            @click="switchTypeView()"
          >
            <i class="fas fa-list text-lg pt-1"></i>
          </button>
  
        </div>
      </div>
    </header>


        <div class="mx-8 w-11/12  bg-gradient-to-b from-purple-400 to-purple-100 rounded-md px-6 pb-12 p-4  h-80p max-80p overflow-y-scroll">
          <div v-if="showingGrid" class="   pt-6  ">

            <div class="grid grid-cols-5 gap-4 w-full">
              <div v-for="item in orderedChallenges" :key="item.identifier" 
                @click="selectChallenge(item)"
              class="rounded block w-56 h-48 mb-1 bg-gradient-to-r from-purple-500 to-red-500 bg-purple-200 text-center align-middle cursor-pointer" 
               @mouseover="mouseOverGrid(item)" @mouseout="hoverBack = ''">
               <div v-if="hoverImageViewable(item)"
                class="w-full h-full rounded bg-cover bg-bottom bg-no-repeat"
               v-bind:style='{ backgroundImage: `url("${setBackImage(item)}")` }'>

                <div class="bottom bg-purple-600"> 
                  <span class="text-bold text-lg text-white uppercase opacity-75 "> {{ item.title }}</span> </div>
              </div>
               <div v-else   class="w-full h-full rounded bg-cover bg-center ">
                <i class="fas fa-question text-5xl text-purple-800 mt-24"></i> 
               </div>

               
              </div>

            </div>

          </div>
          <ChallengeList v-else  @challengeSelected="challengeSelected"></ChallengeList>
        </div>


  </div>
</template>

<script>
import moment from 'moment'

import { mapGetters } from 'vuex'

import { ChallengeService } from "@/services/challenge.service";
const ChallengeList = () => import('@/components/challenges/TheChallengeList.vue')

export default {
  name: 'challenges',
   props: {

    },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess"
    }),
    // title() {
    //   if (this.editView) {
    //     return "Set Pupil to Device"
    //   } else {
    //       let name = this.pupil.undefined ? "" :  this.pupil.name
    //       return name
    //   }

    // },
    componentLoaded () {
      return this.challenges.length > 0
    },
    challengeInAction() {
      return this.selectedChallenge != undefined
    },
    selectedChallengeImage() {
      return require('@/assets/images/challenges/' + this.selectedChallenge.image_url + '.svg')
    },
    orderedChallenges() {
       return this.challenges.sort( () => Math.random() - 0.5).slice(0, 9);
    },
  },
  data () {
    return {
      loading: true,
      school: this.$store.getters.school,
      errored: false,
      challenges: [],
      selectedChallenge: null,
      hoverBack: '',
      showInfoModal: false,
      showingGrid: true
    }
  },
  created() {
    this.fetchChallenges()
  },
  mounted () {
    
  },
  methods: {
    fetchChallenges() {
      ChallengeService.getAll()
        .then(response => this.challenges = response.data.data)
        .catch(err => {
          console.log("challenges " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));

    },
    selectChallenge(challenge) {
      this.selectedChallenge = challenge
      this.$store.commit('setChallenge', this.selectedChallenge)
      this.$router.push({ name: 'ChallengePupils' });
    },
    mouseOverGrid(challenge) {
      this.hoverBack = challenge.image_url
    },
    setBackImage(challenge) {
      if (challenge.image_url.Valid == false) { return "" }

      return require('@/assets/images/challenges/' + challenge.image_url + '_card.svg')
    },
    hoverImageViewable(challenge) {
      if (this.selectedChallenge == undefined) {
        return this.hoverBack === challenge.image_url
      }

      return this.hoverBack === challenge.image_url || this.selectedChallenge.identifier === challenge.identifier
    },
    startRamdomSelection() {
      const vm = this
      let randomOrder = vm.orderedChallenges.sort( () => Math.random() - 0.5)
      randomOrder.forEach((object, i) => {
        setTimeout(() => {
          vm.mouseOverGrid(object)
           if (i === vm.orderedChallenges.length - 1) {
              let sel = vm.orderedChallenges[Math.floor(Math.random() * vm.orderedChallenges.length)]
               setTimeout(() => {
                  vm.mouseOverGrid(sel)
                  vm.selectChallenge(sel)
              }, i * 200);
            }
        }, i * 800);
      });
    },
    switchTypeView () {
      this.showingGrid = !this.showingGrid
    },
    challengeSelected(challenge) {
      this.selectChallenge(challenge)
    }
  },
  components: {
    ChallengeList
    }
}
</script>

<style>

.button-purple {
  @apply text-white bg-purple-700 rounded p-2 w-8/12 mb-4 cursor-pointer inline-flex items-center justify-center;
}

.button-purple:hover {
  opacity: 0.75;
}
</style>